/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-12-12 15:08:09
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-03-28 13:45:53
 * @FilePath: \vue-hepha-order\src\views\warning\queryConfig\WarningListQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

const WarningListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'', // 订单名称
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'160px',
            placeholder:'order.orderName',
        },
        {
            // name:'', // 出库单号
            key:'key2',
            type:'input',   
            allowClear:true,
            width:'160px',
            placeholder:'warning.deliveryNumber',
        },
        {
            // name:'', // 订单类型
            key:'order_channel_type',
            type:'select',   
            allowClear:true,
            width:'160px',
            placeholder:'order.orderChannelType',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                // {
                //     value:2,
                //     label:'order.ECommerceVendor',
                // },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ],
        },
        {
            // name:'', // 仓库
            key:'key3',
            type:'select',   
            allowClear:true,
            width:'160px',
            placeholder:'warning.wms',
            options:[]
        },
        {
            // name:'', // 状态
            key:'warning_status',
            type:'select',   
            allowClear:true,
            width:'160px',
            placeholder:'warning.warningStatus',
            optionToLocale:true,
            options:[
                {
                    value:10,
                    label:'base.ok',
                },
                {
                    value:20,
                    label:'warning.warning',
                },
                {
                    value:30,
                    label:'warning.error',
                },
            ],
        },
        {
            // name:'', // 报警时间
            key:'warning_timestamp',
            type:'dateRange',   
            allowClear:true,
            showTime:false,
            width:'230px',
            placeholder:'warning.warningTimestamp',
            optionToLocale:true,
        },
        
    ]
}



WarningListQuery.formField.forEach(item=>{
    WarningListQuery.formData[item.key] = ''
})

export {
    WarningListQuery
}